<template>
    <section class="flex-container my-4" :class="!idComponentePai ? 'card' : ''">
        <div class="flex flex-col gap-2">
            <div class="flex gap-2">
                <label :for="valorInformado">
                    {{ descricao }}
                    <span v-if="respostaObrigatoria == true" class="text-xs text-vermelho-padrao">*</span>
                </label>
                <Status v-if="idComponentePai == '' || (idComponentePai == '' && resumoModulos == false)" :status="statusResposta" />
            </div>
            <textarea v-if="!resumo" class="block w-full border border-preto-padrao py-1.5 pl-2 pr-20 text-gray-900 bg-white placeholder:text-gray-300 sm:text-sm sm:leading-6 focus:outline-none focus:border-azul-info border-2 border-solid hover:border-blue-500" :name="`texto-${valorInformado}`"
                :id="valorInformado" :placeholder="placeholder ?? descricao" v-model="valorInformado"
                @change="textoInformado"></textarea>
            <p v-else><span class="font-semibold">Resposta:</span> {{ valorInformado ?? '-' }}</p>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import Status from '@/components/Status.vue';
import ComponenteTextoGrandeService from '@/services/componentes/ComponenteTextoGrandeService'
import ComponentesService from '@/services/ComponentesService'

export default defineComponent({
    name: 'TextoGrande',
    components: {
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
        placeholder: {
            type: String,
            default: ''
        }
    },
    watch: {
        valorInformado: {
            handler(valor) {
                if(!this.resumoModulos) {
                    this.statusResposta = ComponenteTextoGrandeService.validarResposta(this.respostaObrigatoria, valor)
                }
            },
            immediate: true
        }
    },
    methods: {
        textoInformado() {
            const resposta = {
                descricao: this.descricao,
                resposta: this.valorInformado
            }
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, resposta, this.idComponentePai)
            this.statusResposta = ComponenteTextoGrandeService.validarResposta(this.respostaObrigatoria, this.valorInformado)
        }
    },
    setup(props) {
        return ComponenteTextoGrandeService.setup(props)
    }
});
</script>